import { qs } from '../utils/index';
import { gsap } from '../libraries/gsap';

export default class Grid {
  constructor() {
    this.grid = qs('.design-grid');
    this.state = {
      toggle: false,
    };

    this.on();
  }

  visibility(e) {
    const grid = this.grid;
    const isCtrlPressed = e.metaKey ? e.metaKey : e.ctrlKey;
    if (e.key === 'g' && isCtrlPressed) {
      if (!this.state.toggle) {
        gsap.to(grid, { duration: 0.5, autoAlpha: 1 });
        this.state.toggle = true;
      } else {
        gsap.to(grid, { duration: 0.5, autoAlpha: 0 });
        this.state.toggle = false;
      }
    }
  }
  on() {
    document.addEventListener('keypress', this.visibility.bind(this));
  }
}
